import { render, staticRenderFns } from "./SingleDeployment.vue?vue&type=template&id=61880701&"
import script from "./SingleDeployment.vue?vue&type=script&lang=js&"
export * from "./SingleDeployment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports